/**
 * TD Collection Tabs Banner — `<collection-tabs-banner>` Web Component.
 */
if (!customElements.get('collection-tabs-banner')) {
  class CollectionTabsBanner extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[data-tab]');
      this.panels = this.querySelectorAll('[data-panel]');
      this.shopAllLinkLabel = this.querySelector('[data-shop-all-link] [data-button-label]');
      this.shopAllLink = this.querySelector('[data-shop-all-link] a');
      this.mobileShopAllLinkLabel = this.querySelector('[data-mobile-shop-all-link] [data-button-label]');
      this.mobileShopAllLink = this.querySelector('[data-mobile-shop-all-link] a');
      this.shopAllLabel = this.getAttribute('data-shop-all-label') || 'Shop all';
      this.tabHandlers = new Map();
    }

    connectedCallback() {
      this.setupEventListeners();
      this.updateShopAllLink();
      this.updateTitle();
      this.refreshEmblaOnActivePanel();
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        const handler = this.tabHandlers.get(tab);
        if (handler) {
          tab.removeEventListener('click', handler);
          this.tabHandlers.delete(tab);
        }
      });
    }

    setupEventListeners() {
      this.tabs.forEach((tab) => {
        const handler = () => {
          this.switchTab(tab.dataset.tab);
        };
        this.tabHandlers.set(tab, handler);
        tab.addEventListener('click', handler);
      });
    }

    switchTab(tabId) {
      const activePanel = this.querySelector('[data-panel].active');
      if (activePanel && activePanel.dataset.panel === tabId) {
        return;
      }

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === tabId;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-pressed', isActive);
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panel === tabId;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
      });

      this.refreshEmblaOnActivePanel();
      this.updateShopAllLink();
      this.updateTitle();
    }

    refreshEmblaOnActivePanel() {
      const activePanel = this.querySelector('[data-panel].active');
      if (!(activePanel instanceof HTMLElement)) {
        return;
      }

      const panelEmblaSliders = activePanel.querySelectorAll('embla-slider');
      panelEmblaSliders.forEach((emblaSlider) => {
        if (emblaSlider.emblaApi && typeof emblaSlider.emblaApi.reInit === 'function') {
          emblaSlider.emblaApi.reInit();
          return;
        }

        emblaSlider.addEventListener(
          'embla:init',
          () => {
            if (emblaSlider.emblaApi && typeof emblaSlider.emblaApi.reInit === 'function') {
              emblaSlider.emblaApi.reInit();
            }
          },
          { once: true }
        );
      });
    }

    updateTitle() {
      const titleElement = this.querySelector('[data-dynamic-title]');
      const activePanel = this.querySelector('[data-panel].active');
      if (titleElement && activePanel) {
        titleElement.textContent = activePanel.dataset.collectionTitle;
      }
    }

    updateShopAllLink() {
      const activePanel = this.querySelector('[data-panel].active');

      if (!activePanel) {
        return;
      }

      const collectionHandle = activePanel.dataset.collectionHandle;
      const collectionTitle = activePanel.dataset.collectionTitle;
      const shopAllText = `${this.shopAllLabel} ${collectionTitle}`;
      const shopAllUrl = `/collections/${collectionHandle}`;

      if (this.shopAllLink && this.shopAllLinkLabel) {
        this.shopAllLinkLabel.textContent = shopAllText;
        this.shopAllLink.href = shopAllUrl;
      }

      if (this.mobileShopAllLink && this.mobileShopAllLinkLabel) {
        this.mobileShopAllLinkLabel.textContent = shopAllText;
        this.mobileShopAllLink.href = shopAllUrl;
      }
    }
  }

  customElements.define('collection-tabs-banner', CollectionTabsBanner);
}
